export enum TypeEntity {
    DriverDestiny = 1,      // Estampa Destino Tenaris que pasa por el evento anonimo para sicram
    DriverSign = 2,         // Firma de origen del driver desde la vista anonima para sicram
    SignDestiny = 3,        // Firma del Companyman del destino no tenaris anonimo para sicram
    EbolOrigin = 4,         // Firma de origen desde la vista no anonima para ebol
    EbolDriverOrigin = 5    // Firma de origen desde la vista no anonima para el driver en ebol
}